export default __webpack_public_path__ + "static/media/software_engineer.1708c340.svg";